<template>
    <div :class="'state-display-container' + ' ' + containerClass">
        <span class="caption">{{caption}}:</span>
        <span class="value">{{value}}</span>
    </div>
</template>

<script>
    export default {
        name: "StateDisplay",
        props: {
            caption: String,
            value: [Number, String],
            containerClass: String,
        }
    }
</script>

<style scoped>
    .state-display-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 14px;
    }
    .caption {

    }
    .value {
        font-weight: bold;
        margin-left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/render/StateDisplay.vue